import React, { FunctionComponent, useMemo } from 'react';
import { getSvgRegistryContext } from './SvgRegistryContext';

export class SvgPartRegistry {
  private readonly unregisterListeners: Record<string, Set<() => unknown>> = {};

  private readonly registry = new Map<string, string>();

  addUnregisterListener = (optimizationId: string, listener: () => unknown) => {
    if (this.unregisterListeners[optimizationId] === undefined) {
      this.unregisterListeners[optimizationId] = new Set();
    }
    this.unregisterListeners[optimizationId].add(listener);

    return () => {
      this.unregisterListeners[optimizationId].delete(listener);

      if (this.unregisterListeners[optimizationId].size === 0) {
        delete this.unregisterListeners[optimizationId];
      }
    };
  };

  hasSvg = (optimizationId: string, instanceId: string) =>
    this.registry.has(optimizationId) &&
    this.registry.get(optimizationId) !== instanceId;

  registerSvg = (optimizationId: string, instanceId: string) => {
    this.registry.set(optimizationId, instanceId);

    return () => {
      this.registry.delete(optimizationId);

      if (this.unregisterListeners[optimizationId] !== undefined) {
        this.unregisterListeners[optimizationId].forEach((callback) =>
          callback()
        );
      }
    };
  };
}

export const SvgOptimizer: FunctionComponent<React.PropsWithChildren<unknown>> =
  ({ children }) => {
    const svgPartRegistry = useMemo(() => new SvgPartRegistry(), []);
    const SvgRegistryContext = getSvgRegistryContext();

    return (
      <SvgRegistryContext.Provider value={svgPartRegistry}>
        {children}
      </SvgRegistryContext.Provider>
    );
  };
